export default {
	dashboard: [
		{
			title: 'Neue Meldungen',
			text:
				'Verschaffen Sie sich einen Überblick darüber in welchen Bearbeitungsstatus sich die Meldungen in Ihrem Zuständigkeitsbereich befinden. Ein Klick auf diese Fläche führt Sie auf die Seite Tabelle.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-1',
			position: 'bottom',
			isFixed: true
		},
		{
			title: 'Neue Nachrichten',
			text: 'Hier sehen Sie ob es zu Meldungen auf die Sie Zugriff haben neue Chatnachrichten gibt.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-2',
			position: 'bottom',
			isFixed: true
		},
		{
			title: 'Statistiken',
			text:
				'Verschaffen Sie sich einen Überblick über die allgemeine Lage in Ihrem Verwaltungsbereich. Dazu stehen Ihnen verschiedene Kennzahlen und Diagramme zur Verfügung. Diese können auf Wunsch auch gerne um andere Kennzahlen oder Diagramme erweitert werden.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-3',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Neue Meldung anlegen',
			text:
				'Haben Sie eine Meldung über Telefon oder Mail erhalten und wollen diese manuell in das System eintragen, damit Sie alle Meldungen übersichtlich in einem System sammeln können? Hier können Sie bequem und schnell eine Meldung in das System eintragen und die Meldung anschließend wie gewohnt bearbeiten. Falls Sie hier eine Email-Adresse angeben, wird auch hier der Melder automatisch über den Fortschritt bei der Bearbeitung seiner Meldung informiert.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-4',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Benachrichtigungen zu Meldungen',
			text:
				'Falls Ihnen eine neue Meldung zugewiesen wird oder sich der Status einer Ihnen zugewiesenen Meldung verändert werden erhalten Sie hier Benachrichtigung darüber. Ein Klick auf eine Benachrichtigung öffnet die jeweilige Meldung. Die Benachrichtigungseinstellungen können Sie im Einstellungsbereich Ihres Profils ändern.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-5',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Benachrichtigungen zu Chats',
			text:
				'Falls Sie eine neue Nachricht zu einer Ihnen zugewiesenen Meldung erhalten, werden Sie hier darüber informiert. Ein Klick auf die Benachrichtigung öffnet die jeweilige Meldung und den Chat mit einer der neuen Nachricht. Die Benachrichtigungseinstellungen können Sie im Einstellungsbereich Ihres Profils ändern.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-6',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Profil & Abmelden',
			text:
				'Hier finden Sie Ihr Profil und die Möglichkeit sich vom System abzumelden. In Ihrem Profil können Sie neben Ihren allgemeinen Daten, Ihrem Passwort auch Ihre Benachrichtichtigungseinstellungen ändern und verschiedene individuelle Vorlagen anlegen.',
			textAlign: 'center',
			selector: '.tour-dashboard-step-7',
			position: 'bottom',
			isFixed: false
		}
	],
	'report-table': [
		{
			title: 'Nicht zugewiesene Meldungen',
			text:
				'Die hier dargstellten Meldungen konnten niemandem zugewiesen werden oder wurden Ihnen von einer anderen Organisation zugewiesen. Um die Meldungen bearbeiten zu können müssen Sie diese zunächst einem Benutzer ober einer Gruppe zuweisen.',
			textAlign: 'center',
			selector: '.tour-report-table-step-1',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Meine Meldungen',
			text:
				'Hier finden Sie alle offenen Meldungen die Ihnen, einer Ihrer Gruppen oder einem Benutzer für den Sie als Vertretung eingetragen sind zugewiesen sind. Ein Klick auf eine Meldung öffnet die Detailansicht in der Sie diverse Bearbeitungsmöglichkeiten haben.',
			textAlign: 'center',
			selector: '.tour-report-table-step-2',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Wiedervolage anzeigen',
			text:
				'In der Detailansicht haben Sie die Möglichkeit Meldungen auf Wiedervolage zu schalten. Hier können Sie Meldungen die aktuell auf Wiedervorlage stehen ein- und ausblenden.',
			textAlign: 'center',
			selector: '.tour-report-table-step-3',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Beobachtete Meldungen',
			text:
				'In der Detailansicht haben Sie die Möglichekit Meldungen an andere Benutzer Gruppen und sogar externe Organisationen weiterzuleiten. Während der Zuweisung gibt es die Möglichkeit den Beobachtungsmodus zu aktivieren. Von Ihnen beobachtete Meldungen werden hier angezeigt.',
			textAlign: 'center',
			selector: '.tour-report-table-step-4',
			position: 'top',
			isFixed: false
		}
	],
	'report-map': [
		{
			title: 'Meldungskarte',
			text:
				'Die Meldungskarte stellt die Standorte der Meldungen dar und ermöglicht Ihnen sich einen optischen Eindruck über die Meldungen in Ihrem Verwaltungsbgebiet zu machen. Ein Klick auf einen Meldungsmarker öffnet die Detailansicht der jeweiligen Meldung.',
			textAlign: 'center',
			selector: '.tour-report-map-step-1',
			position: 'right',
			isFixed: false
		},
		{
			title: 'Übersicht & Meldungen filtern',
			text:
				'Entscheiden Sie selbst welche Meldungen auf der Karte angezeigt werden sollen. Sie dabei haben Sie die Möglichkeit einzelene Meldungen ein- und auszublenden oder verschiedene Filter auf die gesamte Meldungsliste anzuwenden.',
			textAlign: 'center',
			selector: '.tour-report-map-step-2',
			position: 'left',
			isFixed: false
		}
	],
	'report-archive': [
		{
			title: 'Meldungsarchiv',
			text:
				'Das Meldungsarchiv zeigt Ihnen alle abgechlossenen Meldungen. Ob die Meldung als "Erledigt" oder "Gelöscht" markiert wurde erkennen Sie an den farblich gekennzeichneten Statusfeldern. Ein Klick auf eine Meldung öffnet die Detailansicht der jeweiligen Meldung, in welcher Sie auch die Möglichkeit haben die Meldung wiederherzustellen und damit die Bearbeitung der Meldung wieder aufzunehmen.',
			textAlign: 'center',
			selector: '.tour-report-archive-step-1',
			position: 'right',
			isFixed: false
		},
		{
			title: 'Archiv exportieren',
			text:
				'Zur Auswertung und externen Archivierung haben Sie hier die Möglichkeit alle im Archiv befindlichen Meldung als CSV-Datei zu exportieren.',
			textAlign: 'center',
			selector: '.tour-report-archive-step-2',
			position: 'left',
			isFixed: false
		}
	],
	report: [
		{
			title: 'Meldungsstatus auf "Erledigt" setzen',
			text:
				'Klicken Sie auf den "Erledigt"-Button sobald die Bearbeitung der Meldung abgeschlossen ist. Der Meldende wird automatisch über den erfolgreichen Abschluss der Meldung informiert und die Meldung anschließend ins Archiv verschoben. Über den Erweiterungs-Button haben Sie die Möglichkeit eine Nachricht an die Abschlussbenachrichtigung anzuhängen.',
			textAlign: 'center',
			selector: '.tour-report-step-1',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Meldungsstatus auf "Gelöscht" setzen',
			text:
				'Klicken Sie auf den "Löschen"-Button falls Sie Ihrer Meinung nach keine Relevanz hat oder eine Falschmeldung ist. Der Meldende wird automatisch über die Ablehnung der Meldung informiert und die Meldung anschließend ins Archiv verschoben. Über den Erweiterungs-Button haben Sie die Möglichkeit der Ablehnungsbenachrichtigung eine Nachricht anzuhängen. Dabei können Sie auch auf eine Ihrer individuellen Begründungsvorlagen zurückgreifen.',
			textAlign: 'center',
			selector: '.tour-report-step-2',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Meldung Zuweisen',
			text:
				'Sind Sie nicht für die Meldung zuständig? Dann können Sie hier die Meldung einem anderen Benutzer, einer Gruppe, einer externen Organisation oder einem hinterlegten Kontakt zuweisen.',
			textAlign: 'center',
			selector: '.tour-report-step-3',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Meldungsstatus auf "In Bearbeitung" setzen',
			text:
				'Haben mehrere Benutzer Zugriff auf diese Meldung und Sie wollen und Sie wollen kennzeichnen, dass Sie diese Meldung bearbeiten? Dann klicken Sie den "In Bearbeitung"-Button. Auch der Meldende wird darüber informiert, dass die Meldung nun bearbeitet wird.',
			textAlign: 'center',
			selector: '.tour-report-step-4',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Sichtbarkeit der Meldung bearbeiten',
			text:
				'Wenn Sie nicht möchten, dass diese Meldung öffentlich auf der Meldungskarte in der Meldoo-App angezeigt wird können Sie hier den Sichtbarkeitsstatus der Meldung ändern.',
			textAlign: 'center',
			selector: '.tour-report-step-5',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Priorität der Meldung festlegen',
			text:
				'Weisen Sie der Meldung eine Priorität zu um einen besseren Überblick über Ihre Meldungen zu haben. Die Priorität der Meldung wird auch in der Meldungstabelle aufgeführt.',
			textAlign: 'center',
			selector: '.tour-report-step-6',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Meldungsdaten bearbeiten & Meldung exportieren',
			text:
				'Hier können Sie die Meldungsdaten wie Adresse und Kategorie bearbeiten oder einen Meldungstitel festlegen. Auch können Sie gleiche Meldungen mit dieser verknüpfen, Meldungsbilder zensieren, die Meldung exportieren, eine Frist festlegen oder die Meldung auf Wiedervorlage setzen.',
			textAlign: 'center',
			selector: '.tour-report-step-7',
			position: 'bottom',
			isFixed: false
		},
		{
			title: 'Chat mit dem Melder',
			text:
				'Haben Sie Fragen zu der Meldung an den Meldenden oder wollen Sie Ihm etwas mitteilen? Dann können Sie hierfür den Meldungschat benutzen. Der Meldende wird über den Eingang neuer Nachrichten informiert und hat über die Meldoo-App die Möglichkeit Ihnen zu antworten.',
			textAlign: 'center',
			selector: '.tour-report-step-8',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Interne Kommentare',
			text:
				'Die Internen Kommentare bieten Ihnen die Möglichkeit Ihre Arbeit individuell zu dokumentieren oder der Meldung weitere Informationen hinzuzufügen.Interne Kommentare können nur Sie und andere Benutzer die Zugriff auf die Meldung haben einsehen. Der Meldende hat keinen Zugriff auf die Internen Kommentare.',
			textAlign: 'center',
			selector: '.tour-report-step-9',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Bearbeitungsverlauf',
			text:
				'Der Bearbeitungsverlauf stellt alle Bearbeitungschritte die mit der Meldungs zusammenhängen dar und bietet Ihnen so die Möglichkeit den gesamten Meldungsverlauf nachzuvollziehen.',
			textAlign: 'center',
			selector: '.tour-report-step-10',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Meldungen verküpfen',
			text:
				'Sie haben die Möglichkeit gleiche Meldungen mit dieser zu verknüpfen. In der Meldungs-Tabelle wird dann nur noch die Primärmeldung angezeigt. In den Meldungsdetails werden dann alle Bilder, Beschreibungen und Chats der Meldungen zusammengefasst. Falls Sie den Status der Primärmeldung ändern werden auch alle verknüpften Meldungen entsprechend geändert. In diesem Fall werden die Melder aller verknüpften Meldungen zusammen mit dem Meldenden der Primärmeldung über die Statusänderung informiert.',
			textAlign: 'center',
			selector: '.tour-report-step-11',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Geben Sie der Meldung einen Titel',
			text:
				'Der Titel hilft Ihnen die Meldung in der Tabelle schneller einordnen zu können. Außerdem können Sie auch nach dem Meldungstitle suchen.',
			textAlign: 'center',
			selector: '.tour-report-step-12',
			position: 'top',
			isFixed: false
		},
		{
			title: 'Meldungsbilder ein-/ausblenden oder zensieren',
			text:
				'Hier haben Sie die Möglichkeit die öffentliche Darstellung einzelner Meldungsbilder einzustellen oder Bilder zu zensieren auf denen beispielsweise Personen oder Nummerschilder zu sehen sind.',
			textAlign: 'center',
			selector: '.tour-report-step-13',
			position: 'top',
			isFixed: false
		}
	]
};



// WEBPACK FOOTER //
// ./constants/IntroTourData.js